<Teleport to="body">
	<b-modal v-model="isOpen">
		<div class="newsletter-modal">
			<h1 class="title is-2">Newsletter abonnieren</h1>
			<p class="mb-3">Abonnieren Sie unseren Newsletter und erhalten Sie regelmässig Informationen zu unserem aktuellen Programm.</p>
			<NewsletterSignup is-inverted />
		</div>
	</b-modal>
</Teleport>
